<div class="form-group">
  <label class="ui-checkbox input-label">
    <input class="form-control" name="reusable" type="checkbox" value="{{options.reusable}}"
           (change)="setFieldsReusable(options);" [(ngModel)]="options.reusable">
    <span><b>Reusable</b></span>
  </label>
</div>